/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClientContactRequest } from '../models/CreateClientContactRequest';
import type { CreateClientContactResponse } from '../models/CreateClientContactResponse';
import type { LinkedClient } from '../models/LinkedClient';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientsContactsService {
    /**
     * Creates client contact
     * @returns CreateClientContactResponse successful operation
     * @throws ApiError
     */
    public static createClientContact({
        requestBody,
    }: {
        /**
         * New client contact
         */
        requestBody?: CreateClientContactRequest,
    }): CancelablePromise<CreateClientContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/clientContacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
    /**
     * Returns a list of linked clients for a client contact
     * @returns LinkedClient successful operation
     * @throws ApiError
     */
    public static listLinkedClients({
        clientContactId,
    }: {
        clientContactId: number,
    }): CancelablePromise<Array<LinkedClient>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/clientContacts/{clientContactId}/linkedClients',
            path: {
                'clientContactId': clientContactId,
            },
        });
    }
    /**
     * Updates linked clients for a client contact
     * @returns void
     * @throws ApiError
     */
    public static updateLinkedClients({
        clientContactId,
        requestBody,
    }: {
        clientContactId: number,
        requestBody?: Array<string>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/clientContacts/{clientContactId}/linkedClients',
            path: {
                'clientContactId': clientContactId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid parameters`,
            },
        });
    }
}
